// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sunzi__wrapper-hJY8k {\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "sunzi__wrapper-hJY8k"
};
module.exports = exports;
